import angular from 'angular';
import { SharedAngular } from '@Client/@types/sharedAngular';

/**
 * Service for handling Circle community authentication.
 */
export class CircleService {
  public static $inject = ['$http', 'APP_CONFIG'];

  constructor(
    private $http: angular.IHttpService,
    private APP_CONFIG: SharedAngular.APP_CONFIG
  ) {}

  public openCommunity(): angular.IPromise<void> {
    return this.$http
      .post(`${this.APP_CONFIG.apiBaseUrl}circle/token`, null, {
        responseType: 'text'
      })
      .then((response) => {
        const accessToken = response.data;
        const communityDomain = 'community.flowingly.net'; // Make configurable if needed
        const url = `https://${communityDomain}/session/cookies?access_token=${accessToken}`;
        window.open(url, '_blank');
      });
  }
}

angular
  .module('flowingly.runner.services')
  .service('circleService', CircleService);

export type CircleServiceType = InstanceType<typeof CircleService>;
